import React from "react";
import { InvoiceManagement } from "./InvoiceManagement";

const PaymentAndInvoice = () => {
  return <InvoiceManagement />;
};

export default PaymentAndInvoice;
